document.addEventListener('DOMContentLoaded', function () {
  const blocksWrapper = document.querySelector('.bundle-collection-data');
  const blocks = Array.from(blocksWrapper.querySelectorAll('.block-content'));
  const totalBlocks = blocks.length;

  const itemsPerPage = 5;
  let currentPage = 1;

  const filters = {
    style: [],
    application: [],
    shield: [],
  };

  const paginationContainer = document.querySelector('.pagination-container');
  const paginationControls = document.getElementById('pagination-controls');
  const prevArrow = document.querySelector('.pagination-prevArrow');
  const nextArrow = document.querySelector('.pagination-nextArrow');
  const filtersDisplay = document.querySelector('.bundle-filters-display');

  const extendedFilterBox = document.querySelector(
    '.bundle-collection-container .extended-filter-box',
  );
  const filterOpenButtons = document.querySelectorAll('.filter-block-parent .filter-block');
  const filterCloseButtons = document.querySelectorAll(
    '.bundle-collection-container .bundle-collection-close-filter-svg, .bundle-collection-container .filter-done',
  );

  // --- MOBILE FILTER TOGGLE ---
  filterOpenButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (extendedFilterBox) extendedFilterBox.style.display = 'block';
    });
  });

  filterCloseButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (extendedFilterBox) extendedFilterBox.style.display = 'none';
    });
  });

  // --- FILTERS ---
  function applyFilters() {
    return blocks.filter((block) => {
      const style = block.dataset.style || '';
      const application = block.dataset.application || '';
      const shield = block.dataset.shield || '';

      const styleMatch = filters.style.length ? filters.style.includes(style) : true;
      const appMatch = filters.application.length
        ? filters.application.includes(application)
        : true;
      const shieldMatch = filters.shield.length ? filters.shield.includes(shield) : true;

      return styleMatch && appMatch && shieldMatch;
    });
  }

  function renderBlocks(page = 1) {
    const filteredBlocks = applyFilters();
    const start = (page - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    document.querySelector('.collection-page [data-template*="bundle"] .bundle-products-section').scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
    setTimeout(function() {
      blocks.forEach((block) => (block.style.display = 'none'));
      filteredBlocks.slice(start, end).forEach((block) => (block.style.display = 'block'));

      renderPagination(filteredBlocks.length);
      renderSelectedFilters();
    }, 2000);
  }

  // --- PAGINATION ---
  function renderPagination(filteredTotal) {
    const totalPages = Math.ceil(filteredTotal / itemsPerPage);
    paginationControls.innerHTML = '';

    // ✅ Hide pagination completely if not needed
    if (filteredTotal <= itemsPerPage) {
      paginationContainer.style.display = 'none';
      return;
    } else {
      paginationContainer.style.display = 'flex';
    }

    // --- PREV ARROW ---
    if (currentPage > 1) {
      prevArrow.style.visibility = 'visible';
    } else {
      prevArrow.style.visibility = 'hidden';
    }

    // --- PAGE NUMBERS ---
    for (let i = 1; i <= totalPages; i++) {
      let pageEl;
      if (i === currentPage) {
        pageEl = document.createElement('span');
        pageEl.className =
          'pagination__current radius-small text-neutral text-body-3-medium active';
        pageEl.textContent = i;
      } else {
        pageEl = document.createElement('a');
        pageEl.href = '#';
        pageEl.className = 'pagination__link radius-small text-neutral text-body-3-medium';
        pageEl.textContent = i;
        pageEl.addEventListener('click', (e) => {
          e.preventDefault();
          currentPage = i;
          renderBlocks(currentPage);
        });
      }
      paginationControls.appendChild(pageEl);
    }

    // --- NEXT ARROW ---
    if (currentPage < totalPages) {
      nextArrow.style.visibility = 'visible';
    } else {
      nextArrow.style.visibility = 'hidden';
    }
  }

  prevArrow.addEventListener('click', (e) => {
    e.preventDefault();
    if (currentPage > 1) {
      currentPage--;
      renderBlocks(currentPage);
    }
  });

  nextArrow.addEventListener('click', (e) => {
    e.preventDefault();
    const filteredBlocks = applyFilters();
    const totalPages = Math.ceil(filteredBlocks.length / itemsPerPage);
    if (currentPage < totalPages) {
      currentPage++;
      renderBlocks(currentPage);
    }
  });

  // --- SELECTED FILTERS DISPLAY ---
  function renderSelectedFilters() {
    filtersDisplay.innerHTML = '';
    const allSelected = [];

    Object.keys(filters).forEach((key) => {
      filters[key].forEach((value) => {
        allSelected.push({ key, value });
      });
    });

    if (allSelected.length === 0) {
      filtersDisplay.classList.add('hide');
    } else {
      filtersDisplay.classList.remove('hide');
    }

    const filterButtonsContainer = document.querySelector(
      '.bundle-collection-filter-buttons-container',
    );
    if (filterButtonsContainer) {
      if (allSelected.length > 0) filterButtonsContainer.classList.remove('hide');
      else filterButtonsContainer.classList.add('hide');
    }

    allSelected.forEach((filter) => {
      const filterEl = document.createElement('div');
      filterEl.className = 'selected-filter text-body-3-medium text-neutral gap-4 radius-circular';
      filterEl.textContent = filter.value;

      const removeBtn = document.createElement('span');
      removeBtn.className = 'remove-filter';
      removeBtn.innerHTML = `
        <span class="svg-wrapper svg-wrapper--smaller">
          <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.52861 3.9286C3.78896 3.66825 4.21107 3.66825 4.47141 3.9286L8.00001 7.4572L11.5286 3.9286C11.789 3.66825 12.2111 3.66825 12.4714 3.9286C12.7318 4.18895 12.7318 4.61106 12.4714 4.87141L8.94282 8.4L12.4714 11.9286C12.7318 12.1889 12.7318 12.6111 12.4714 12.8714C12.2111 13.1318 11.789 13.1318 11.5286 12.8714L8.00001 9.34281L4.47141 12.8714C4.21107 13.1318 3.78896 13.1318 3.52861 12.8714C3.26826 12.6111 3.26826 12.1889 3.52861 11.9286L7.0572 8.4L3.52861 4.87141C3.26826 4.61106 3.26826 4.18895 3.52861 3.9286Z" fill="#14181F"></path>
          </svg>
        </span>
      `;
      removeBtn.addEventListener('click', () => {
        filters[filter.key] = filters[filter.key].filter((v) => v !== filter.value);
        document.querySelectorAll(`.bundle-${filter.key}-checkbox`).forEach((cb) => {
          if (cb.value === filter.value) cb.checked = false;
        });
        renderBlocks(currentPage);
      });

      filterEl.appendChild(removeBtn);
      filtersDisplay.appendChild(filterEl);
    });
  }

  // --- HANDLE FILTER CLICK ---
  function setupFilterEvents() {
    document.querySelectorAll('.bundle-style-checkbox').forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        filters.style = Array.from(document.querySelectorAll('.bundle-style-checkbox:checked')).map(
          (el) => el.value,
        );
        currentPage = 1;
        renderBlocks(currentPage);
      });
    });

    document.querySelectorAll('.bundle-application-checkbox').forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        filters.application = Array.from(
          document.querySelectorAll('.bundle-application-checkbox:checked'),
        ).map((el) => el.value);
        currentPage = 1;
        renderBlocks(currentPage);
      });
    });

    document.querySelectorAll('.bundle-shield-checkbox').forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        filters.shield = Array.from(
          document.querySelectorAll('.bundle-shield-checkbox:checked'),
        ).map((el) => el.value);
        currentPage = 1;
        renderBlocks(currentPage);
      });
    });

    const resetBtn = document.querySelector('.clear-filter');
    if (resetBtn) {
      resetBtn.addEventListener('click', () => {
        document.querySelectorAll('.bundle-custom-checkbox').forEach((cb) => (cb.checked = false));
        filters.style = [];
        filters.application = [];
        filters.shield = [];
        currentPage = 1;
        renderBlocks(currentPage);
      });
    }
  }

  // --- ACCORDIONS ---
  const accordions = document.querySelectorAll('.bundle-collection-filter');
  accordions.forEach((filter) => {
    const label = filter.querySelector('.bundle-filter-label');
    const content = filter.querySelector('.bundle-collection-content');

    if (!label || !content) return;
    if (!label.classList.contains('open')) content.style.display = 'none';

    label.addEventListener('click', () => {
      const isOpen = label.classList.contains('open');
      if (isOpen) {
        content.style.display = 'none';
        label.classList.remove('open');
      } else {
        content.style.display = 'block';
        label.classList.add('open');
      }
    });
  });

  // --- INITIAL RENDER ---
  setupFilterEvents();
  renderBlocks(currentPage);
});